<template>
  <div class="device_sleep">
    <div class="message_top_abnormal">
      <img src="@/assets/img/abnormal.svg" alt="" />
    </div>

    <img class="device_img" :src="currentDevice.icon" :class="{ margin_bottom: currentDevice.deviceType == DeviceType.keyboard }" />

    <div class="message_action" v-if="currentDevice.deviceType == DeviceType.mouse">
      {{ $t('message_device_error') }}
    </div>
    <div class="message_action_kb" v-if="currentDevice.deviceType == DeviceType.keyboard">
      <div class="kb_message">{{ $t('message_device_kb1_error') }}</div>
      <div class="kb_message">{{ $t('message_device_kb2_error') }}</div>
    </div>
    <div class="exit_sleep" v-if="!specialCheckCurrent(speciaBehiver.DeviceOfRoyuan)" @click="exitSleep">{{ $t('back_sleep') }}</div>
  </div>
</template>

<script setup lang="ts">
import { DeviceManager } from '../../service/device'
import { getCurrentDevice } from '../../profiles/selector'
import { computed } from 'vue'
import { DeviceType } from '@libs/types/enum'
import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
const exitSleep = () => {
  DeviceManager.instance.state.deviceStatus.IsSleep = false
}

const currentDevice = computed(() => getCurrentDevice.value)
</script>

<style scoped lang="less">
.device_sleep {
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  width: 100%;
  flex: 1;

  .exit_sleep {
    margin-top: 30px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-app-region: no-drag;
    font-size: 16px;
    text-align: center;
    line-height: 42px;
    padding-left: 30px;
    padding-right: 30px;
    color: #ffffff;
    border-radius: var(--radius-m);
    border: 1px solid #ffffff;
  }
}

.message_top_abnormal {
  background-color: rgba(#ffffff, 0.2);
  border-radius: var(--radius-m);
  width: 88px;
  height: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.device_img {
  object-fit: contain;
  width: 800px;
  height: 400px;
  margin-top: 40px;
  margin-bottom: 43px;

  &.margin_bottom {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
}

.message_action {
  font-size: 30px;
  color: #fff;
  text-align: center;
}

.message_action_kb {
  text-align: start;
  max-width: 904px;

  .kb_message {
    font-size: 20px;
    margin-top: 12px;
    line-height: 1.5;

    .kb_message:nth-child(1) {
      margin-top: 0px;
    }
  }
}
</style>
